import React from 'react';
import './MapBoxConsentDialog.scss';
import * as Klaro from 'klaro';
import getKlaroConfig from '../../../config/klaro';
import { useTranslation } from '../../../config/TranslationProvider';

const MapBoxConsentDialog = () => {
    const changeConsent = () => {
        const consentManager = Klaro.getManager(getKlaroConfig());
        consentManager.updateConsent('mapbox', true);
        consentManager.saveAndApplyConsents();
    };

    return (
        <div className="mapbox-consent-dialog-container">
            <div className="mapbox-consent-dialog">
                <p style={{ color: '#3a3a3a', textAlign: 'center' }}>
                    {useTranslation('mapbox_consent_dialog')}
                </p>
                <div className="button-container">
                    <span className="button" role="button" onClick={changeConsent}>
                        {useTranslation('yes')}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default MapBoxConsentDialog;